import { useContext, useEffect, useRef } from 'react'
import { LayerName } from '../../../../../util/model';
import { CesiumViewerContext } from '../cesiumviewer/CesiumViewer'
import {Entity, CallbackProperty, Cartesian3} from 'cesium';


interface Props {
    label: string;
    pos: number[];
    size: number;
}

export default function SNLabel(props: Props) {
    const viewer = useContext(CesiumViewerContext)
    const entityRef = useRef<Entity>()
    useEffect(() => {
        if (!viewer) {
            return () => { }
        }
        const position = Cartesian3.fromDegrees(
            props.pos[0],
            props.pos[1],
            props.pos[2]
        );
        const e = viewer.entities.add({
            position,
            label: {
                text: props.label,
                scale: props.size
            }
        } as any);
        entityRef.current = e;
        return () => { viewer!.entities.remove(e) }
    }, [viewer]);

    useEffect(() => {
        if(!entityRef.current) {
            return;
        }
        const entity = entityRef.current;
        (entity as any).label.text.setValue(props.label)
    }, [props.label])

    useEffect(() => {
        if (!entityRef.current) {
            return;
        }
        const entity = entityRef.current;
        const position = new CallbackProperty((time, result) => {
            return Cartesian3.fromDegrees(
                props.pos[0],
                props.pos[1],
                props.pos[2]
            )
        }, true) as any;
        entity!.position = position;
    }, [props.pos]);

    useEffect(() => {
        if (!entityRef.current) {
            return;
        }
        const entity = entityRef.current;
        (entity as any).label.scale.setValue(props.size)
    }, [props.size])

    return null;
}
